class CountdownTimer extends HTMLElement {
  constructor() {
    super();
  }

  static get observedAttributes() {
    return ["state"];
  }

  selectors = {
    days: "countdown-timer-days",
    hours: "countdown-timer-hours",
    minutes: "countdown-timer-minutes",
    seconds: "countdown-timer-seconds"
  };

  modifiers = {
    hidden: "hidden",
    disabled: "disabled"
  };

  attributes = {
    datetime: {
      start: "start-datetime",
      end: "end-datetime",
    },
    state: "state",
    button: {
      copy: {
        expired: "data-expired-copy",
        upcoming: "data-upcoming-copy"
      }
    }
  };

  states = {
    expired: "expired",
    current: "current",
    upcoming: "upcoming"
  };

  connectedCallback() {
    const startDatetimeString = this.getAttribute(this.attributes.datetime.start);
    const endDatetimeString = this.getAttribute(this.attributes.datetime.end);

    if (!startDatetimeString || !endDatetimeString) {
      this.setAttribute(this.attributes.state, this.states.expired);
      return;
    }

    this.startDatetime = new Date(startDatetimeString);
    this.endDatetime = new Date(endDatetimeString);

    this.startTimer();
  }

  get state() {
    return this.getAttribute(this.attributes.state);
  }

  startTimer() {
    const currentDatetime = this.getCurrentDatetime();

    if (currentDatetime < this.startDatetime) {
      this.setAttribute(this.attributes.state, this.states.upcoming);
    } else if (currentDatetime >= this.startDatetime && currentDatetime <= this.endDatetime) {
      this.setAttribute(this.attributes.state, this.states.current);
      this.updateTimer();
    } else {
      this.setAttribute(this.attributes.state, this.states.expired);
    }

    document.dispatchEvent(new CustomEvent("countdown:init"));
  }

  updateTimer() {
    const intervalId = setInterval(() => {
      const currentDatetime = this.getCurrentDatetime();
      const timeDifference = this.endDatetime - currentDatetime;

      if (timeDifference < 0) {
        this.setAttribute(this.attributes.state, this.states.expired);
        clearInterval(intervalId);
      } else {
        const hours = Math.floor(timeDifference / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        this.querySelector(this.selectors.hours).innerHTML = this.getDigitsAsSpans(hours);
        this.querySelector(this.selectors.minutes).innerHTML = this.getDigitsAsSpans(minutes);
        this.querySelector(this.selectors.seconds).innerHTML = this.getDigitsAsSpans(seconds);
      }
    }, 1000);
  }

  getCurrentDatetime() {
    const currentDatetimeString = new Date().toLocaleString("en-US", {
      timeZone: "America/New_York",
    });

    return new Date(currentDatetimeString);
  }

  updateLinkedButtons() {
    const buttons = [...document.querySelectorAll(`[data-countdown-timer="${this.id}"]`)];

    if (!buttons.length) {
      return;
    }

    buttons.forEach((button) => {
      const buttonCopy = this.state === this.states.expired ? button.getAttribute(this.attributes.button.copy.expired) : button.getAttribute(this.attributes.button.copy.upcoming);

      button.classList.add(this.modifiers.disabled);
      button.innerHTML = buttonCopy;
    });
  }

  getDigitsAsSpans(value) {
    const valueString = value.toString().padStart(2, "0");

    return valueString
      .split("")
      .map(digit => `<span>${digit}</span>`)
      .join("");
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === this.attributes.state) {
      if (newValue === this.states.upcoming || newValue === this.states.expired) {
        this.classList.add(this.modifiers.hidden);
        this.updateLinkedButtons();
      }
    }
  }
}

if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}
